import client from 'webpack-theme-color-replacer/client'
import {
	generate
} from '@ant-design/colors'

export default {
	currentColor: '#1890ff',
	// 主题色对应的侧边栏背景色映射
	siderBgColorMap: {
		'#e85827': '#FFF1EC', // 橙色
		'#2c62c4': '#F2F6FE', // 蓝色
		'#002ea6': '#F2F6FE', // 深蓝
		'#7fa91f': '#FBFFF0', // 绿色
		'#c8161d': '#FEF2F2', // 火焰红
		'#800020': '#FFEFEF', // 酒红
		'#003153': '#EBF4FF', // 海蓝
		'#008c8c': '#EBFFFF'  // 马尔斯绿
	},
	// 直接设置侧边栏背景色
	setSiderBgColor(color) {
		document.documentElement.style.setProperty('--sider-bg-color', color)
	},
	initTheme() {
		const saveColor = localStorage.getItem('color');
		// const color = saveColor || this.defaultColor
		const color = saveColor || this.currentColor
		console.log(saveColor)
		this.changeColor(color)
	},
	// 获取侧边栏背景色
	getSiderBgColor(color) {
		// 转换为小写，确保匹配
		const lowerColor = color.toLowerCase()
		return this.siderBgColorMap[lowerColor] || '#f0f2f5'
	},
	getAntdSerials(color) {
		// 淡化（即less的tint）
		const lightens = new Array(9).fill().map((t, i) => {
			return client.varyColor.lighten(color, i / 10)
		})
		// colorPalette变换得到颜色值
		const colorPalettes = generate(color)
		const rgb = client.varyColor.toNum3(color.replace('#', '')).join(',')
		return lightens.concat(colorPalettes).concat(rgb)
	},
	changeColor(newColor) {
		localStorage.setItem('theme-color', newColor)
		// 更新根元素css变量
		document.documentElement.style.setProperty('--theme-color', newColor)
		// 更新侧边栏背景色
		const siderBgColor = this.getSiderBgColor(newColor)
		document.documentElement.style.setProperty('--sider-bg-color', siderBgColor)
		// 触发主题色变化事件
		const event = new CustomEvent('theme-color-changed', {
			detail: { color: newColor }
		})
		window.dispatchEvent(event)
		var options = {
			newColors: this.getAntdSerials(newColor), // new colors array, one-to-one corresponde with `matchColors`
			changeUrl(cssUrl) {
				console.log(cssUrl)
				return `/${cssUrl}` // while router is not `hash` mode, it needs absolute path
			}
		}
		return client.changer.changeColor(options, Promise)
	},
	// 直接修改侧边栏背景色的方法
	updateSiderBgColor(color) {
		this.setSiderBgColor(color);
		// 也可以同时更新主题色
		// this.changeColor(color)
	}
}